/**
 * CreatorAudiencePage Duck
 *
 * State management for creator's audience lists
 */

import { storableError } from '../../util/errors';
import { audienceAPI } from '../../util/api';
import { usersAPI } from '../../api/clients/usersAPI';

// ================ Action types ================ //

export const SET_ACTIVE_TAB = 'app/CreatorAudiencePage/SET_ACTIVE_TAB';

export const FETCH_LISTS_REQUEST = 'app/CreatorAudiencePage/FETCH_LISTS_REQUEST';
export const FETCH_LISTS_SUCCESS = 'app/CreatorAudiencePage/FETCH_LISTS_SUCCESS';
export const FETCH_LISTS_ERROR = 'app/CreatorAudiencePage/FETCH_LISTS_ERROR';

export const CREATE_LIST_REQUEST = 'app/CreatorAudiencePage/CREATE_LIST_REQUEST';
export const CREATE_LIST_SUCCESS = 'app/CreatorAudiencePage/CREATE_LIST_SUCCESS';
export const CREATE_LIST_ERROR = 'app/CreatorAudiencePage/CREATE_LIST_ERROR';

export const UPDATE_LIST_REQUEST = 'app/CreatorAudiencePage/UPDATE_LIST_REQUEST';
export const UPDATE_LIST_SUCCESS = 'app/CreatorAudiencePage/UPDATE_LIST_SUCCESS';
export const UPDATE_LIST_ERROR = 'app/CreatorAudiencePage/UPDATE_LIST_ERROR';

export const DELETE_LIST_REQUEST = 'app/CreatorAudiencePage/DELETE_LIST_REQUEST';
export const DELETE_LIST_SUCCESS = 'app/CreatorAudiencePage/DELETE_LIST_SUCCESS';
export const DELETE_LIST_ERROR = 'app/CreatorAudiencePage/DELETE_LIST_ERROR';

export const FETCH_LIST_DETAIL_REQUEST = 'app/CreatorAudiencePage/FETCH_LIST_DETAIL_REQUEST';
export const FETCH_LIST_DETAIL_SUCCESS = 'app/CreatorAudiencePage/FETCH_LIST_DETAIL_SUCCESS';
export const FETCH_LIST_DETAIL_ERROR = 'app/CreatorAudiencePage/FETCH_LIST_DETAIL_ERROR';

export const ADD_MEMBER_TO_LIST_REQUEST = 'app/CreatorAudiencePage/ADD_MEMBER_TO_LIST_REQUEST';
export const ADD_MEMBER_TO_LIST_SUCCESS = 'app/CreatorAudiencePage/ADD_MEMBER_TO_LIST_SUCCESS';
export const ADD_MEMBER_TO_LIST_ERROR = 'app/CreatorAudiencePage/ADD_MEMBER_TO_LIST_ERROR';

export const IMPORT_MEMBERS_REQUEST = 'app/CreatorAudiencePage/IMPORT_MEMBERS_REQUEST';
export const IMPORT_MEMBERS_SUCCESS = 'app/CreatorAudiencePage/IMPORT_MEMBERS_SUCCESS';
export const IMPORT_MEMBERS_ERROR = 'app/CreatorAudiencePage/IMPORT_MEMBERS_ERROR';

export const FETCH_SUBSCRIBERS_REQUEST = 'app/CreatorAudiencePage/FETCH_SUBSCRIBERS_REQUEST';
export const FETCH_SUBSCRIBERS_SUCCESS = 'app/CreatorAudiencePage/FETCH_SUBSCRIBERS_SUCCESS';
export const FETCH_SUBSCRIBERS_ERROR = 'app/CreatorAudiencePage/FETCH_SUBSCRIBERS_ERROR';

export const REMOVE_MEMBER_REQUEST = 'app/CreatorAudiencePage/REMOVE_MEMBER_REQUEST';
export const REMOVE_MEMBER_SUCCESS = 'app/CreatorAudiencePage/REMOVE_MEMBER_SUCCESS';
export const REMOVE_MEMBER_ERROR = 'app/CreatorAudiencePage/REMOVE_MEMBER_ERROR';

export const FETCH_IMPORTS_REQUEST = 'app/CreatorAudiencePage/FETCH_IMPORTS_REQUEST';
export const FETCH_IMPORTS_SUCCESS = 'app/CreatorAudiencePage/FETCH_IMPORTS_SUCCESS';
export const FETCH_IMPORTS_ERROR = 'app/CreatorAudiencePage/FETCH_IMPORTS_ERROR';

export const ADD_BY_EMAIL_REQUEST = 'app/CreatorAudiencePage/ADD_BY_EMAIL_REQUEST';
export const ADD_BY_EMAIL_SUCCESS = 'app/CreatorAudiencePage/ADD_BY_EMAIL_SUCCESS';
export const ADD_BY_EMAIL_ERROR = 'app/CreatorAudiencePage/ADD_BY_EMAIL_ERROR';

export const IMPORT_SUBSCRIBERS_REQUEST = 'app/CreatorAudiencePage/IMPORT_SUBSCRIBERS_REQUEST';
export const IMPORT_SUBSCRIBERS_SUCCESS = 'app/CreatorAudiencePage/IMPORT_SUBSCRIBERS_SUCCESS';
export const IMPORT_SUBSCRIBERS_ERROR = 'app/CreatorAudiencePage/IMPORT_SUBSCRIBERS_ERROR';

export const MATCH_SUBSCRIBERS_REQUEST = 'app/CreatorAudiencePage/MATCH_SUBSCRIBERS_REQUEST';
export const MATCH_SUBSCRIBERS_SUCCESS = 'app/CreatorAudiencePage/MATCH_SUBSCRIBERS_SUCCESS';
export const MATCH_SUBSCRIBERS_ERROR = 'app/CreatorAudiencePage/MATCH_SUBSCRIBERS_ERROR';

export const FETCH_AUDIENCE_USERS_SUCCESS = 'app/CreatorAudiencePage/FETCH_AUDIENCE_USERS_SUCCESS';

export const CLEAR_ERRORS = 'app/CreatorAudiencePage/CLEAR_ERRORS';

// Email campaigns
export const FETCH_EMAILS_REQUEST = 'app/CreatorAudiencePage/FETCH_EMAILS_REQUEST';
export const FETCH_EMAILS_SUCCESS = 'app/CreatorAudiencePage/FETCH_EMAILS_SUCCESS';
export const FETCH_EMAILS_ERROR = 'app/CreatorAudiencePage/FETCH_EMAILS_ERROR';

export const CREATE_EMAIL_REQUEST = 'app/CreatorAudiencePage/CREATE_EMAIL_REQUEST';
export const CREATE_EMAIL_SUCCESS = 'app/CreatorAudiencePage/CREATE_EMAIL_SUCCESS';
export const CREATE_EMAIL_ERROR = 'app/CreatorAudiencePage/CREATE_EMAIL_ERROR';

export const UPDATE_EMAIL_REQUEST = 'app/CreatorAudiencePage/UPDATE_EMAIL_REQUEST';
export const UPDATE_EMAIL_SUCCESS = 'app/CreatorAudiencePage/UPDATE_EMAIL_SUCCESS';
export const UPDATE_EMAIL_ERROR = 'app/CreatorAudiencePage/UPDATE_EMAIL_ERROR';

export const DELETE_EMAIL_REQUEST = 'app/CreatorAudiencePage/DELETE_EMAIL_REQUEST';
export const DELETE_EMAIL_SUCCESS = 'app/CreatorAudiencePage/DELETE_EMAIL_SUCCESS';
export const DELETE_EMAIL_ERROR = 'app/CreatorAudiencePage/DELETE_EMAIL_ERROR';

export const SEND_EMAIL_REQUEST = 'app/CreatorAudiencePage/SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = 'app/CreatorAudiencePage/SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_ERROR = 'app/CreatorAudiencePage/SEND_EMAIL_ERROR';

// ================ Reducer ================ //

const initialState = {
  activeTab: 'lists', // 'lists' | 'subscribers' | 'emails'

  // Lists state
  lists: [],
  listsLoading: false,
  listsLoaded: false,
  listsError: null,

  // Create list
  createListInProgress: false,
  createListError: null,

  // Update list
  updateListInProgress: false,
  updateListError: null,

  // Delete list
  deleteListInProgress: null, // listId being deleted
  deleteListError: null,

  // List detail
  selectedList: null,
  selectedListLoading: false,
  selectedListError: null,

  // Add member
  addMemberInProgress: false,
  addMemberError: null,

  // Import
  importInProgress: false,
  importResult: null,
  importError: null,

  // Subscribers
  subscribers: [],
  subscribersLoading: false,
  subscribersLoaded: false,
  subscribersError: null,
  subscribersPagination: null,

  // Remove member
  removeMemberInProgress: null, // memberId being removed
  removeMemberError: null,

  // Import history
  imports: [],
  importsLoading: false,
  importsError: null,

  // Add by email
  addByEmailInProgress: false,
  addByEmailError: null,

  // Import subscribers (global)
  importSubscribersInProgress: false,
  importSubscribersResult: null,
  importSubscribersError: null,

  // Account matching
  matchInProgress: false,

  // Live Sharetribe user objects for matched subscribers, keyed by userId
  usersById: {},

  // Emails
  emails: [],
  emailsLoading: false,
  emailsLoaded: false,
  emailsError: null,
  createEmailInProgress: false,
  createEmailError: null,
  updateEmailInProgress: false,
  updateEmailError: null,
  deleteEmailInProgress: null, // emailId being deleted
  deleteEmailError: null,
  sendEmailInProgress: null, // emailId being sent
  sendEmailError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: payload,
      };

    // Fetch lists
    case FETCH_LISTS_REQUEST:
      return {
        ...state,
        listsLoading: true,
        listsError: null,
      };
    case FETCH_LISTS_SUCCESS:
      return {
        ...state,
        listsLoading: false,
        listsLoaded: true,
        lists: payload,
      };
    case FETCH_LISTS_ERROR:
      return {
        ...state,
        listsLoading: false,
        listsError: payload,
      };

    // Create list
    case CREATE_LIST_REQUEST:
      return {
        ...state,
        createListInProgress: true,
        createListError: null,
        importError: null,
      };
    case CREATE_LIST_SUCCESS: {
      const initialMembers = payload?.members || [];
      const existingSubscriberIds = new Set(state.subscribers.map(s => s.id));
      const newSubscribers = initialMembers
        .filter(m => !existingSubscriberIds.has(m.id))
        .map(m => ({
          ...m,
          hasAccount: false,
          consent: { newsletter: true, marketing: false, updatedAt: Date.now() },
          subscriptions: [],
        }));
      return {
        ...state,
        createListInProgress: false,
        lists: [...state.lists, payload],
        subscribers:
          newSubscribers.length > 0 ? [...newSubscribers, ...state.subscribers] : state.subscribers,
      };
    }
    case CREATE_LIST_ERROR:
      return {
        ...state,
        createListInProgress: false,
        createListError: payload,
      };

    // Update list
    case UPDATE_LIST_REQUEST:
      return {
        ...state,
        updateListInProgress: true,
        updateListError: null,
      };
    case UPDATE_LIST_SUCCESS:
      return {
        ...state,
        updateListInProgress: false,
        lists: state.lists.map(list => (list.id === payload.id ? payload : list)),
        selectedList: state.selectedList?.id === payload.id ? payload : state.selectedList,
      };
    case UPDATE_LIST_ERROR:
      return {
        ...state,
        updateListInProgress: false,
        updateListError: payload,
      };

    // Delete list
    case DELETE_LIST_REQUEST:
      return {
        ...state,
        deleteListInProgress: payload, // listId
        deleteListError: null,
      };
    case DELETE_LIST_SUCCESS:
      return {
        ...state,
        deleteListInProgress: null,
        lists: state.lists.filter(list => list.id !== payload),
      };
    case DELETE_LIST_ERROR:
      return {
        ...state,
        deleteListInProgress: null,
        deleteListError: payload,
      };

    // Fetch list detail
    case FETCH_LIST_DETAIL_REQUEST:
      return {
        ...state,
        selectedListLoading: true,
        selectedListError: null,
      };
    case FETCH_LIST_DETAIL_SUCCESS:
      return {
        ...state,
        selectedListLoading: false,
        selectedList: payload,
      };
    case FETCH_LIST_DETAIL_ERROR:
      return {
        ...state,
        selectedListLoading: false,
        selectedListError: payload,
      };

    // Add member to list
    case ADD_MEMBER_TO_LIST_REQUEST:
      return {
        ...state,
        addMemberInProgress: true,
        addMemberError: null,
      };
    case ADD_MEMBER_TO_LIST_SUCCESS: {
      const newMembers = payload.members || [];
      // Add new members to selectedList.members (with tags default)
      const listMembers = newMembers.map(m => ({ tags: [], ...m }));
      // Add to subscribers only if not already present (check by id)
      const existingSubscriberIds = new Set(state.subscribers.map(s => s.id));
      const newSubscribers = newMembers
        .filter(m => !existingSubscriberIds.has(m.id))
        .map(m => ({
          ...m,
          tags: [],
          hasAccount: false,
          consent: { newsletter: true, marketing: false, updatedAt: Date.now() },
          subscriptions: [],
        }));
      return {
        ...state,
        addMemberInProgress: false,
        selectedList: state.selectedList
          ? {
              ...state.selectedList,
              members: [...(state.selectedList.members || []), ...listMembers],
              memberCount: (state.selectedList.memberCount || 0) + (payload.count || 0),
            }
          : null,
        lists: state.lists.map(list =>
          list.id === payload.listId
            ? { ...list, memberCount: (list.memberCount || 0) + (payload.count || 0) }
            : list
        ),
        subscribers:
          newSubscribers.length > 0 ? [...newSubscribers, ...state.subscribers] : state.subscribers,
      };
    }
    case ADD_MEMBER_TO_LIST_ERROR:
      return {
        ...state,
        addMemberInProgress: false,
        addMemberError: payload,
      };

    // Import members
    case IMPORT_MEMBERS_REQUEST:
      return {
        ...state,
        importInProgress: true,
        importResult: null,
        importError: null,
      };
    case IMPORT_MEMBERS_SUCCESS: {
      const addedCount = payload.data?.summary?.added || 0;
      return {
        ...state,
        importInProgress: false,
        importResult: payload,
        selectedList:
          state.selectedList && state.selectedList.id === payload.listId
            ? {
                ...state.selectedList,
                memberCount: (state.selectedList.memberCount || 0) + addedCount,
              }
            : state.selectedList,
        lists: state.lists.map(list =>
          list.id === payload.listId
            ? { ...list, memberCount: (list.memberCount || 0) + addedCount }
            : list
        ),
      };
    }
    case IMPORT_MEMBERS_ERROR:
      return {
        ...state,
        importInProgress: false,
        importError: payload,
      };

    // Fetch subscribers
    case FETCH_SUBSCRIBERS_REQUEST:
      return {
        ...state,
        subscribersLoading: true,
        subscribersError: null,
      };
    case FETCH_SUBSCRIBERS_SUCCESS:
      return {
        ...state,
        subscribersLoading: false,
        subscribersLoaded: true,
        subscribers: payload.audience,
        subscribersPagination: payload.pagination,
      };
    case FETCH_SUBSCRIBERS_ERROR:
      return {
        ...state,
        subscribersLoading: false,
        subscribersError: payload,
      };

    // Remove member
    case REMOVE_MEMBER_REQUEST:
      return {
        ...state,
        removeMemberInProgress: payload,
        removeMemberError: null,
      };
    case REMOVE_MEMBER_SUCCESS:
      return {
        ...state,
        removeMemberInProgress: null,
        subscribers: state.subscribers.filter(m => m.id !== payload),
      };
    case REMOVE_MEMBER_ERROR:
      return {
        ...state,
        removeMemberInProgress: null,
        removeMemberError: payload,
      };

    // Fetch imports
    case FETCH_IMPORTS_REQUEST:
      return { ...state, importsLoading: true, importsError: null };
    case FETCH_IMPORTS_SUCCESS:
      return { ...state, importsLoading: false, imports: payload };
    case FETCH_IMPORTS_ERROR:
      return { ...state, importsLoading: false, importsError: payload };

    // Add by email
    case ADD_BY_EMAIL_REQUEST:
      return { ...state, addByEmailInProgress: true, addByEmailError: null };
    case ADD_BY_EMAIL_SUCCESS:
      return { ...state, addByEmailInProgress: false };
    case ADD_BY_EMAIL_ERROR:
      return { ...state, addByEmailInProgress: false, addByEmailError: payload };

    // Import subscribers
    case IMPORT_SUBSCRIBERS_REQUEST:
      return {
        ...state,
        importSubscribersInProgress: true,
        importSubscribersResult: null,
        importSubscribersError: null,
      };
    case IMPORT_SUBSCRIBERS_SUCCESS:
      return {
        ...state,
        importSubscribersInProgress: false,
        importSubscribersResult: payload,
        imports: [payload.importRecord, ...state.imports],
      };
    case IMPORT_SUBSCRIBERS_ERROR:
      return { ...state, importSubscribersInProgress: false, importSubscribersError: payload };

    // Match subscribers
    case MATCH_SUBSCRIBERS_REQUEST:
      return { ...state, matchInProgress: true };
    case MATCH_SUBSCRIBERS_SUCCESS:
      return { ...state, matchInProgress: false };
    case MATCH_SUBSCRIBERS_ERROR:
      return { ...state, matchInProgress: false };

    case FETCH_AUDIENCE_USERS_SUCCESS:
      return { ...state, usersById: { ...state.usersById, ...payload } };

    // Fetch emails
    case FETCH_EMAILS_REQUEST:
      return { ...state, emailsLoading: true, emailsError: null };
    case FETCH_EMAILS_SUCCESS:
      return { ...state, emailsLoading: false, emailsLoaded: true, emails: payload };
    case FETCH_EMAILS_ERROR:
      return { ...state, emailsLoading: false, emailsError: payload };

    // Create email
    case CREATE_EMAIL_REQUEST:
      return { ...state, createEmailInProgress: true, createEmailError: null };
    case CREATE_EMAIL_SUCCESS:
      return {
        ...state,
        createEmailInProgress: false,
        emails: payload ? [...state.emails, payload] : state.emails,
      };
    case CREATE_EMAIL_ERROR:
      return { ...state, createEmailInProgress: false, createEmailError: payload };

    // Update email
    case UPDATE_EMAIL_REQUEST:
      return { ...state, updateEmailInProgress: true, updateEmailError: null };
    case UPDATE_EMAIL_SUCCESS:
      return {
        ...state,
        updateEmailInProgress: false,
        emails: state.emails.map(e => (e.id === payload.id ? payload : e)),
      };
    case UPDATE_EMAIL_ERROR:
      return { ...state, updateEmailInProgress: false, updateEmailError: payload };

    // Delete email
    case DELETE_EMAIL_REQUEST:
      return { ...state, deleteEmailInProgress: payload, deleteEmailError: null };
    case DELETE_EMAIL_SUCCESS:
      return {
        ...state,
        deleteEmailInProgress: null,
        emails: state.emails.filter(e => e.id !== payload),
      };
    case DELETE_EMAIL_ERROR:
      return { ...state, deleteEmailInProgress: null, deleteEmailError: payload };

    // Send email
    case SEND_EMAIL_REQUEST:
      return { ...state, sendEmailInProgress: payload, sendEmailError: null };
    case SEND_EMAIL_SUCCESS:
      return {
        ...state,
        sendEmailInProgress: null,
        emails: state.emails.map(e => (e.id === payload.id ? payload : e)),
      };
    case SEND_EMAIL_ERROR:
      return { ...state, sendEmailInProgress: null, sendEmailError: payload };

    case CLEAR_ERRORS:
      return {
        ...state,
        listsError: null,
        createListError: null,
        updateListError: null,
        deleteListError: null,
        selectedListError: null,
        addMemberError: null,
        importError: null,
        addByEmailError: null,
        importSubscribersError: null,
        emailsError: null,
        createEmailError: null,
        updateEmailError: null,
        deleteEmailError: null,
        sendEmailError: null,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setActiveTab = tab => ({
  type: SET_ACTIVE_TAB,
  payload: tab,
});

export const fetchListsRequest = () => ({
  type: FETCH_LISTS_REQUEST,
});

export const fetchListsSuccess = lists => ({
  type: FETCH_LISTS_SUCCESS,
  payload: lists,
});

export const fetchListsError = error => ({
  type: FETCH_LISTS_ERROR,
  payload: error,
});

export const createListRequest = () => ({
  type: CREATE_LIST_REQUEST,
});

export const createListSuccess = list => ({
  type: CREATE_LIST_SUCCESS,
  payload: list,
});

export const createListError = error => ({
  type: CREATE_LIST_ERROR,
  payload: error,
});

export const updateListRequest = () => ({
  type: UPDATE_LIST_REQUEST,
});

export const updateListSuccess = list => ({
  type: UPDATE_LIST_SUCCESS,
  payload: list,
});

export const updateListError = error => ({
  type: UPDATE_LIST_ERROR,
  payload: error,
});

export const deleteListRequest = listId => ({
  type: DELETE_LIST_REQUEST,
  payload: listId,
});

export const deleteListSuccess = listId => ({
  type: DELETE_LIST_SUCCESS,
  payload: listId,
});

export const deleteListError = error => ({
  type: DELETE_LIST_ERROR,
  payload: error,
});

export const fetchListDetailRequest = () => ({
  type: FETCH_LIST_DETAIL_REQUEST,
});

export const fetchListDetailSuccess = list => ({
  type: FETCH_LIST_DETAIL_SUCCESS,
  payload: list,
});

export const fetchListDetailError = error => ({
  type: FETCH_LIST_DETAIL_ERROR,
  payload: error,
});

export const addMemberToListRequest = () => ({
  type: ADD_MEMBER_TO_LIST_REQUEST,
});

export const addMemberToListSuccess = member => ({
  type: ADD_MEMBER_TO_LIST_SUCCESS,
  payload: member,
});

export const addMemberToListError = error => ({
  type: ADD_MEMBER_TO_LIST_ERROR,
  payload: error,
});

export const importMembersRequest = () => ({
  type: IMPORT_MEMBERS_REQUEST,
});

export const importMembersSuccess = result => ({
  type: IMPORT_MEMBERS_SUCCESS,
  payload: result,
});

export const importMembersError = error => ({
  type: IMPORT_MEMBERS_ERROR,
  payload: error,
});

export const fetchSubscribersRequest = () => ({
  type: FETCH_SUBSCRIBERS_REQUEST,
});

export const fetchSubscribersSuccess = data => ({
  type: FETCH_SUBSCRIBERS_SUCCESS,
  payload: data,
});

export const fetchSubscribersError = error => ({
  type: FETCH_SUBSCRIBERS_ERROR,
  payload: error,
});

export const removeMemberRequest = memberId => ({
  type: REMOVE_MEMBER_REQUEST,
  payload: memberId,
});

export const removeMemberSuccess = memberId => ({
  type: REMOVE_MEMBER_SUCCESS,
  payload: memberId,
});

export const removeMemberError = error => ({
  type: REMOVE_MEMBER_ERROR,
  payload: error,
});

export const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

export const fetchImportsRequest = () => ({ type: FETCH_IMPORTS_REQUEST });
export const fetchImportsSuccess = imports => ({ type: FETCH_IMPORTS_SUCCESS, payload: imports });
export const fetchImportsError = error => ({ type: FETCH_IMPORTS_ERROR, payload: error });

export const addByEmailRequest = () => ({ type: ADD_BY_EMAIL_REQUEST });
export const addByEmailSuccess = () => ({ type: ADD_BY_EMAIL_SUCCESS });
export const addByEmailError = error => ({ type: ADD_BY_EMAIL_ERROR, payload: error });

export const importSubscribersRequest = () => ({ type: IMPORT_SUBSCRIBERS_REQUEST });
export const importSubscribersSuccess = data => ({
  type: IMPORT_SUBSCRIBERS_SUCCESS,
  payload: data,
});
export const importSubscribersError = error => ({ type: IMPORT_SUBSCRIBERS_ERROR, payload: error });

export const matchSubscribersRequest = () => ({ type: MATCH_SUBSCRIBERS_REQUEST });
export const matchSubscribersSuccess = () => ({ type: MATCH_SUBSCRIBERS_SUCCESS });
export const matchSubscribersError = () => ({ type: MATCH_SUBSCRIBERS_ERROR });

export const fetchAudienceUsersSuccess = usersById => ({
  type: FETCH_AUDIENCE_USERS_SUCCESS,
  payload: usersById,
});

export const fetchEmailsRequest = () => ({ type: FETCH_EMAILS_REQUEST });
export const fetchEmailsSuccess = emails => ({ type: FETCH_EMAILS_SUCCESS, payload: emails });
export const fetchEmailsError = error => ({ type: FETCH_EMAILS_ERROR, payload: error });

export const createEmailRequest = () => ({ type: CREATE_EMAIL_REQUEST });
export const createEmailSuccess = email => ({ type: CREATE_EMAIL_SUCCESS, payload: email });
export const createEmailError = error => ({ type: CREATE_EMAIL_ERROR, payload: error });

export const updateEmailRequest = () => ({ type: UPDATE_EMAIL_REQUEST });
export const updateEmailSuccess = email => ({ type: UPDATE_EMAIL_SUCCESS, payload: email });
export const updateEmailError = error => ({ type: UPDATE_EMAIL_ERROR, payload: error });

export const deleteEmailRequest = emailId => ({ type: DELETE_EMAIL_REQUEST, payload: emailId });
export const deleteEmailSuccess = emailId => ({ type: DELETE_EMAIL_SUCCESS, payload: emailId });
export const deleteEmailError = error => ({ type: DELETE_EMAIL_ERROR, payload: error });

export const sendEmailRequest = emailId => ({ type: SEND_EMAIL_REQUEST, payload: emailId });
export const sendEmailSuccess = email => ({ type: SEND_EMAIL_SUCCESS, payload: email });
export const sendEmailError = error => ({ type: SEND_EMAIL_ERROR, payload: error });

// ================ Thunks ================ //

/**
 * Fetch all audience lists for the current creator
 */
export const fetchLists = () => async (dispatch, getState, sdk) => {
  dispatch(fetchListsRequest());

  try {
    const response = await audienceAPI.getLists();
    const lists = response.data?.data?.lists || [];
    dispatch(fetchListsSuccess(lists));
    return lists;
  } catch (error) {
    dispatch(fetchListsError(storableError(error)));
    throw error;
  }
};

/**
 * Create a new audience list
 * @param {Object} listData - { name, type, emails?, fileData? }
 */
export const createList = listData => async (dispatch, getState, sdk) => {
  dispatch(createListRequest());

  try {
    // Create list + add initial emails in one atomic server request
    const response = await audienceAPI.createList({
      name: listData.name,
      type: listData.type || 'custom',
      emails: listData.emails || [],
      attestation: listData.attestation || null,
    });
    const list = response.data?.list;

    dispatch(createListSuccess(list));

    // If file data was provided, import after creation (list now exists on server)
    if (list && listData.fileData) {
      try {
        await audienceAPI.importMembers(list.id, {
          csvData: listData.fileData.data,
          fileName: listData.fileData.fileName,
          attestation: listData.attestation || null,
        });
      } catch (importFailure) {
        // The list exists, so it stays; the list's page shows why it has no one from the file
        dispatch(importMembersError(storableError(importFailure)));
      }
    }

    return list;
  } catch (error) {
    dispatch(createListError(storableError(error)));
    throw error;
  }
};

/**
 * Update an existing list
 */
export const updateList = (listId, updates) => async (dispatch, getState, sdk) => {
  dispatch(updateListRequest());

  try {
    const response = await audienceAPI.updateList(listId, updates);
    const list = response.data?.list;
    dispatch(updateListSuccess(list));
    return list;
  } catch (error) {
    dispatch(updateListError(storableError(error)));
    throw error;
  }
};

/**
 * Delete a list
 */
export const deleteList = listId => async (dispatch, getState, sdk) => {
  dispatch(deleteListRequest(listId));

  try {
    await audienceAPI.deleteList(listId);
    dispatch(deleteListSuccess(listId));
    return listId;
  } catch (error) {
    dispatch(deleteListError(storableError(error)));
    throw error;
  }
};

/**
 * Fetch list detail with members
 */
export const fetchListDetail = (listId, silent = false) => async (dispatch, getState, sdk) => {
  if (!silent) dispatch(fetchListDetailRequest());

  try {
    const response = await audienceAPI.getList(listId);
    const list = response.data?.data?.list;
    dispatch(fetchListDetailSuccess(list));
    return list;
  } catch (error) {
    if (!silent) dispatch(fetchListDetailError(storableError(error)));
  }
};

// Read-only variant that returns a list's detail without touching the
// selectedList slice — needed by AddMembersToListModal's "Add from
// another list" path (we want to inspect the source list's members
// without swapping out the target list we're currently viewing).
export const fetchListDetailBare = listId => async (dispatch, getState, sdk) => {
  const response = await audienceAPI.getList(listId);
  return response.data?.data?.list;
};

/**
 * Add members to a list by email
 */
export const addMemberToList = (listId, emails, attestation) => async (dispatch, getState, sdk) => {
  dispatch(addMemberToListRequest());

  try {
    // Send individual request for each email
    const results = [];
    for (const email of emails) {
      const response = await audienceAPI.addMember(listId, { email, attestation });
      const member = response.data?.member;
      if (member) {
        results.push(member);
      }
    }

    dispatch(addMemberToListSuccess({ listId, members: results, count: results.length }));

    return results;
  } catch (error) {
    dispatch(addMemberToListError(storableError(error)));
    throw error;
  }
};

/**
 * Import members to a list via CSV
 */
export const importMembers = (listId, csvData, attestation) => async (dispatch, getState, sdk) => {
  dispatch(importMembersRequest());

  try {
    // csvData may be { fileName, data } object or a raw string
    const csvString = typeof csvData === 'object' && csvData.data ? csvData.data : csvData;
    const response = await audienceAPI.importMembers(listId, { csvData: csvString, attestation });
    dispatch(importMembersSuccess({ ...response.data, listId }));
    dispatch(fetchListDetail(listId, true));

    return response.data;
  } catch (error) {
    dispatch(importMembersError(storableError(error)));
    throw error;
  }
};

/**
 * Fetch all subscribers (audience members)
 */
export const fetchSubscribers = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchSubscribersRequest());

  try {
    const response = await audienceAPI.query(params);
    const data = response.data?.data || {};
    const audience = data.audience || [];
    dispatch(
      fetchSubscribersSuccess({
        audience,
        pagination: data.pagination || null,
      })
    );

    // Batch-fetch live Sharetribe user objects for matched subscribers
    const matchedIds = audience.filter(m => m.hasAccount && m.userId).map(m => m.userId);
    if (matchedIds.length > 0) {
      const userResponses = await Promise.all(matchedIds.map(id => usersAPI.show({ id })));
      const usersById = {};
      userResponses.forEach(res => {
        const user = res.data?.data;
        if (user?.id?.uuid) usersById[user.id.uuid] = user;
      });
      dispatch(fetchAudienceUsersSuccess(usersById));
    }

    return data;
  } catch (error) {
    dispatch(fetchSubscribersError(storableError(error)));
    throw error;
  }
};

/**
 * Remove a member from the audience list
 */
export const removeMember = memberId => async (dispatch, getState, sdk) => {
  dispatch(removeMemberRequest(memberId));

  try {
    await audienceAPI.removeMember(memberId);
    dispatch(removeMemberSuccess(memberId));
  } catch (error) {
    dispatch(removeMemberError(storableError(error)));
    throw error;
  }
};

/**
 * Fetch import history
 */
export const fetchImports = () => async dispatch => {
  dispatch(fetchImportsRequest());
  try {
    const response = await audienceAPI.getImports();
    dispatch(fetchImportsSuccess(response.data?.data?.imports || []));
  } catch (error) {
    dispatch(fetchImportsError(storableError(error)));
    throw error;
  }
};

/**
 * Add subscribers by email (comma-separated)
 */
export const addSubscribersByEmail = (emailsString, attestation) => async dispatch => {
  dispatch(addByEmailRequest());
  try {
    const emails = emailsString
      .split(',')
      .map(e => e.trim())
      .filter(Boolean);
    for (const email of emails) {
      await audienceAPI.add({ email, attestation });
    }
    dispatch(addByEmailSuccess());
    // Refresh subscribers list
    dispatch(fetchSubscribers());
  } catch (error) {
    dispatch(addByEmailError(storableError(error)));
    throw error;
  }
};

/**
 * Import subscribers from CSV file
 */
export const importSubscribersFile = (csvData, fileName, attestation) => async dispatch => {
  dispatch(importSubscribersRequest());
  try {
    const response = await audienceAPI.import({ csvData, fileName, attestation });
    const summary = response.data?.summary || {};
    const importRecord = {
      id: Date.now().toString(),
      fileName: fileName || 'Upload',
      status: 'imported',
      date: new Date().toISOString(),
      emails: summary.totalRows || 0,
      added: summary.added || 0,
      skipped: (summary.duplicates || 0) + (summary.invalid || 0) + (summary.suppressed || 0),
    };
    dispatch(importSubscribersSuccess({ ...response.data, importRecord }));
    // Refresh subscribers list
    dispatch(fetchSubscribers());
  } catch (error) {
    dispatch(importSubscribersError(storableError(error)));
    throw error;
  }
};

/**
 * Match audience members to platform accounts by email.
 * Only runs if there are unmatched members (hasAccount == null).
 * After matching, re-fetches subscribers to reflect updated data.
 */
export const matchSubscribers = () => async (dispatch, getState) => {
  const state = getState();
  const subscribers = state.CreatorAudiencePage.subscribers;
  const needsMatching = subscribers.some(
    s => s.hasAccount == null || (s.hasAccount === true && !s.firstName && !s.profileImageUrl)
  );
  if (!needsMatching) return;

  dispatch(matchSubscribersRequest());
  try {
    await audienceAPI.matchSubscribers();
    dispatch(matchSubscribersSuccess());
    // Re-fetch so UI shows updated avatars and hasAccount flags
    dispatch(fetchSubscribers());
  } catch (error) {
    dispatch(matchSubscribersError());
    // Non-fatal: silently fail, will retry on next visit
  }
};

export const fetchEmails = () => async dispatch => {
  dispatch(fetchEmailsRequest());
  try {
    const response = await audienceAPI.getEmails();
    dispatch(fetchEmailsSuccess(response.data?.data?.emails || []));
  } catch (error) {
    dispatch(fetchEmailsError(storableError(error)));
    throw error;
  }
};

export const createEmail = emailData => async dispatch => {
  dispatch(createEmailRequest());
  try {
    const response = await audienceAPI.createEmail(emailData);
    const email = response?.email;
    dispatch(createEmailSuccess(email));
    return email;
  } catch (error) {
    dispatch(createEmailError(storableError(error)));
    throw error;
  }
};

export const updateEmail = (emailId, updates) => async dispatch => {
  dispatch(updateEmailRequest());
  try {
    const response = await audienceAPI.updateEmail(emailId, updates);
    const email = response?.email;
    dispatch(updateEmailSuccess(email));
    return email;
  } catch (error) {
    dispatch(updateEmailError(storableError(error)));
    throw error;
  }
};

export const deleteEmail = emailId => async dispatch => {
  dispatch(deleteEmailRequest(emailId));
  try {
    await audienceAPI.deleteEmail(emailId);
    dispatch(deleteEmailSuccess(emailId));
  } catch (error) {
    dispatch(deleteEmailError(storableError(error)));
    throw error;
  }
};

export const sendEmail = emailId => async dispatch => {
  dispatch(sendEmailRequest(emailId));
  try {
    const response = await audienceAPI.sendEmail(emailId);
    const email = response?.email;
    dispatch(sendEmailSuccess(email));
    return email;
  } catch (error) {
    dispatch(sendEmailError(storableError(error)));
    throw error;
  }
};

// ================ Selectors ================ //

export const selectActiveTab = state => state.CreatorAudiencePage.activeTab;
export const selectLists = state => state.CreatorAudiencePage.lists;
export const selectListsLoading = state => state.CreatorAudiencePage.listsLoading;
export const selectListsLoaded = state => state.CreatorAudiencePage.listsLoaded;
export const selectListsError = state => state.CreatorAudiencePage.listsError;
export const selectCreateListInProgress = state => state.CreatorAudiencePage.createListInProgress;
export const selectCreateListError = state => state.CreatorAudiencePage.createListError;
export const selectUpdateListInProgress = state => state.CreatorAudiencePage.updateListInProgress;
export const selectDeleteListInProgress = state => state.CreatorAudiencePage.deleteListInProgress;
export const selectSelectedList = state => state.CreatorAudiencePage.selectedList;
export const selectSelectedListLoading = state => state.CreatorAudiencePage.selectedListLoading;
export const selectAddMemberInProgress = state => state.CreatorAudiencePage.addMemberInProgress;
export const selectImportInProgress = state => state.CreatorAudiencePage.importInProgress;
export const selectImportError = state => state.CreatorAudiencePage.importError;
export const selectImportResult = state => state.CreatorAudiencePage.importResult;
export const selectSubscribers = state => state.CreatorAudiencePage.subscribers;
export const selectSubscribersLoading = state => state.CreatorAudiencePage.subscribersLoading;
export const selectSubscribersLoaded = state => state.CreatorAudiencePage.subscribersLoaded;
export const selectSubscribersError = state => state.CreatorAudiencePage.subscribersError;
export const selectSubscribersPagination = state => state.CreatorAudiencePage.subscribersPagination;
export const selectRemoveMemberInProgress = state =>
  state.CreatorAudiencePage.removeMemberInProgress;
export const selectImports = state => state.CreatorAudiencePage.imports;
export const selectImportsLoading = state => state.CreatorAudiencePage.importsLoading;
export const selectImportsError = state => state.CreatorAudiencePage.importsError;
export const selectAddByEmailInProgress = state => state.CreatorAudiencePage.addByEmailInProgress;
export const selectAddByEmailError = state => state.CreatorAudiencePage.addByEmailError;
export const selectImportSubscribersInProgress = state =>
  state.CreatorAudiencePage.importSubscribersInProgress;
export const selectImportSubscribersResult = state =>
  state.CreatorAudiencePage.importSubscribersResult;
export const selectUsersById = state => state.CreatorAudiencePage.usersById;
export const selectImportSubscribersError = state =>
  state.CreatorAudiencePage.importSubscribersError;
export const selectMatchInProgress = state => state.CreatorAudiencePage.matchInProgress;
export const selectEmails = state => state.CreatorAudiencePage.emails;
export const selectEmailsLoading = state => state.CreatorAudiencePage.emailsLoading;
export const selectEmailsLoaded = state => state.CreatorAudiencePage.emailsLoaded;
export const selectEmailsError = state => state.CreatorAudiencePage.emailsError;
export const selectCreateEmailInProgress = state => state.CreatorAudiencePage.createEmailInProgress;
export const selectCreateEmailError = state => state.CreatorAudiencePage.createEmailError;
export const selectUpdateEmailInProgress = state => state.CreatorAudiencePage.updateEmailInProgress;
export const selectUpdateEmailError = state => state.CreatorAudiencePage.updateEmailError;
export const selectDeleteEmailInProgress = state => state.CreatorAudiencePage.deleteEmailInProgress;
export const selectSendEmailInProgress = state => state.CreatorAudiencePage.sendEmailInProgress;
export const selectSendEmailError = state => state.CreatorAudiencePage.sendEmailError;

// ================ loadData ================ //

/**
 * Page-mount fetches for Creator Audience: lists, subscribers, and email
 * campaigns. Fired in parallel by the route's loadData hook so the page
 * mounts with redux already hydrated — replaces the prior useEffect
 * inside the component (project rule: data fetching goes through
 * loadData + the duck, never useEffect + API client inside a component).
 */
export const loadData = () => dispatch =>
  Promise.all([dispatch(fetchLists()), dispatch(fetchSubscribers()), dispatch(fetchEmails())]);
